module.exports = __webpack_public_path__ + "static/media/greyglove.37c66f61.svg";